<!-- src/components/layout/Header.svelte -->
<script>
  import { router } from '../../lib/router.js';
  import logo from '../../assets/down-to-earth-logo-arrow-sign.svg';
  
  // Navigation items
  const nav_items = [
    { href: '/', label: 'Home' },
    { href: '/ai-lift', label: 'AI LIFT' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
  ];

  function handle_navigation(href) {
    router.navigate(href);
  }
</script>

<header class="site_header">
  <div class="header_container">
    <a href="/" class="logo_link" on:click|preventDefault={() => handle_navigation('/')}>
      <img 
        src={logo}
        alt="Down to Earth Guides Logo" 
        class="logo"
        width="40"
        height="40"
      />
    </a>
    
    <nav class="main_nav">
      {#each nav_items as item}
        <a 
          href={item.href}
          class="nav_link"
          class:active={$router.path === item.href}
          on:click|preventDefault={() => handle_navigation(item.href)}
        >
          {item.label}
        </a>
      {/each}
    </nav>
  </div>
</header>

<style>
  .site_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(5px);
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .header_container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo_link {
    display: block;
  }

  .logo {
    height: 40px;
    width: 40px;
  }

  .main_nav {
    display: flex;
    gap: 2rem;
  }

  .nav_link {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
  }

  .nav_link:hover {
    color: #0066cc;
  }

  .nav_link.active {
    color: #0066cc;
    border-bottom: 2px solid #0066cc;
  }
</style> 